// extracted by mini-css-extract-plugin
module.exports = {"Footer":"styles_Footer__2CWdU","Footer-content":"styles_Footer-content__3hKux","Footer-logo":"styles_Footer-logo__4ZQJe","Footer-credits":"styles_Footer-credits__3YCcL"};